import template from './am-asset-view.html';
class AmAssetViewController {
  constructor(amAssetsService, $stateParams, $state, amStoreService) {
    'ngInject';
    this.assetService = amAssetsService;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.status = '';
    this.store = amStoreService;
  }
  $onInit() {
    this.asset = this.store.viewedAsset;
    this.getAssetData(this.$stateParams.id);
  }
  $onChanges() {}
  $onDestroy() {}
  getAssetData(id) {
    this.status = 'loading';
    this.assetService
      .getAssetById(id)
      .then(asset => {
        this.status = '';
        this.asset = asset;
      })
      .catch(() => {
        this.status = 'error';
      });
  }
}

export default {
  template,
  controller: AmAssetViewController,
  controllerAs: 'assetVm',
  bindings: {}
};
